"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeBaseSchema = void 0;
const zod_1 = require("zod");
const IModePrecondition_1 = require("./IModePrecondition");
const IModeStateConfig_1 = require("./IModeStateConfig");
exports.ModeBaseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    preconditions: zod_1.z
        .lazy(() => IModePrecondition_1.IModePreconditionSchema)
        .array()
        .optional(),
    stateConfig: IModeStateConfig_1.IModeStateConfigSchema.optional(),
});
//# sourceMappingURL=ModeBase.js.map